import * as actions from "@p81-common/shell-core-js/dist/redux/signedUrlPost";

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [actions.SIGNED_URL_POST_REQUEST]: (state) => ({
    ...state,
    loading: true,
    loaded: false,
    error: null,
    data: null,
  }),
  [actions.SIGNED_URL_POST_REQUEST_SUCCESS]: (state, action) => ({
    ...state,
    loading: false,
    loaded: true,
    error: null,
    data: action.data,
  }),
  [actions.SIGNED_URL_POST_REQUEST_FAILURE]: (state, action) => ({
    ...state,
    loading: false,
    loaded: false,
    error: action.error,
    data: null,
  }),
};

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {
  loaded: false,
  loading: false,
  error: null,
  data: null,
};

export default function signedUrlPostReducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}
